import React from 'react';
import LegacyIcon, { IconProps } from './Icon.legacy';
import AlphaIcon from './Icon.alpha';

const Component = process.env.IS_LEGACY ? LegacyIcon : AlphaIcon;
export default Component as React.FC<IconProps>;
export type { IconProps };
